import React from 'react';
import ReportPageWithMonthWeekSwitch from './components/ReportPageWithMonthWeekSwitch';
import GamesModifiedByMonthByUserList from './components/month/GamesModifiedByMonthByUserList';
import GamesModifiedByWeekByUserList from './components/week/GamesModifiedByWeekByUserList';

function GamesModifiedByUser() {
  return (
    <ReportPageWithMonthWeekSwitch
      title="Games modified by user"
      MonthList={GamesModifiedByMonthByUserList}
      WeekList={GamesModifiedByWeekByUserList}
    />
  );
}

export default GamesModifiedByUser;
